// Output formats the image tools can save, and which one "keep the format" means.
import type { FileKind } from "@/lib/files";

export type OutputFormat = "jpg" | "png" | "webp";

export const OUTPUT_FORMATS: Record<
  OutputFormat,
  { label: string; mime: string; ext: string; lossy: boolean }
> = {
  jpg: { label: "JPG", mime: "image/jpeg", ext: "jpg", lossy: true },
  png: { label: "PNG", mime: "image/png", ext: "png", lossy: false },
  webp: { label: "WebP", mime: "image/webp", ext: "webp", lossy: true },
};

/** "keep" saves JPG/PNG/WebP as they are; HEIC and AVIF photos become JPG,
 *  GIF and BMP (often graphics with sharp edges) become PNG. */
export function outputFormatFor(
  input: FileKind | null,
  choice: OutputFormat | "keep",
): OutputFormat {
  if (choice !== "keep") return choice;
  switch (input) {
    case "png":
    case "gif":
    case "bmp":
      return "png";
    case "webp":
      return "webp";
    default:
      return "jpg";
  }
}

/** Formats that can show see-through pixels. */
export function keepsTransparency(format: OutputFormat): boolean {
  return format !== "jpg";
}

/** For Compress: only JPG and WebP get smaller through quality. "keep" leaves
 *  JPG/WebP as they are, turns PNG/GIF/BMP into WebP (keeps transparency) and
 *  HEIC/AVIF photos into JPG. */
export function compressFormatFor(
  input: FileKind | null,
  choice: "keep" | "jpg" | "webp",
): "jpg" | "webp" {
  if (choice !== "keep") return choice;
  switch (input) {
    case "webp":
    case "png":
    case "gif":
    case "bmp":
      return "webp";
    default:
      return "jpg";
  }
}
